import { useClientsData } from "@shared/utils/hooks/misc.ts";
import { useMemo } from "react";

const useAccounts = () => {
  const {
    activeClientsData,
    getAccountById,
    getAccountByName,
    getAccountExchangeById,
  } = useClientsData();

  const getAccountsNames = (accountsIds: number[]) => {
    return accountsIds
      .map((accountId) => getAccountById(accountId)?.client_name)
      .filter((account) => account) as string[];
  };

  const getAccountsIds = (accountsNames: string[]) => {
    return accountsNames
      .map((accountName) => getAccountByName(accountName)?.client_id)
      .filter((id) => id) as number[];
  };

  const clientToExchangeMapping = useMemo(() => {
    return activeClientsData?.reduce((acc, account) => {
      acc[account.client_name] =
        getAccountExchangeById(account.client_id) || "";
      return acc;
    }, {} as Record<string, string>);
  }, [activeClientsData]);

  return {
    activeClientsData,
    getAccountsNames,
    getAccountsIds,
    clientToExchangeMapping,
  };
};

export default useAccounts;
